window.addEventListener("load", function () {
  if (
    !window.Shopify.customerPrivacy.marketingAllowed() ||
    !window.Shopify.customerPrivacy.analyticsProcessingAllowed() ||
    !window.Shopify.customerPrivacy.saleOfDataAllowed()
  ) {
    window.Shopify.customerPrivacy.setTrackingConsent(
      {
        analytics: true,
        marketing: true,
        preferences: true,
        sale_of_data: true,
      },
      function () {
        dwInit();
      }
    );
  } else {
    dwInit();
  }
});

function dwInit() {
  window.setTimeout(function () {
    dwInitScroll();
    dwInitCartPage();
    dwInitCartOpen();
    dwInitExternalLinks();
    dwInitPhoneLinks();
    dwInitEmailLinks();
    dwInitContactForm();
    dwInitReviewOpened();
    dwInitWriteReview();
    dwInitNewsletterEbook();
    dwInitReturn();
    dwInitCompleteRegistration();

    //console.log("dw-custom-events-init: finished");
  }, 1000);
}

function dwInitExternalLinks() {
  document.addEventListener("click", (event) => {
    const link = event.target.closest("a");
    if (!link) return;

    const href = link.href;
    if (!href) return;

    const targetDomains = ["yogaakademieaustria.com", "pages.flylightyoga.net"];

    try {
      const url = new URL(href);
      const domain = url.hostname.replace("www.", "");

      if (targetDomains.includes(domain)) {
        // ads conversion
        gtag("event", "conversion", {
          send_to: "AW-10815322900/QB16CIimlOYZEJT2kqUo",
        });

        // ga4 event
        gtag("event", "link_click", {
          URL: href,
          Titel: document.title,
        });

        // meta conversion
        if (typeof fbq !== "undefined") {
          fbq("trackCustom", "Externer Link", {
            URL: href,
            Titel: document.title,
          });
        }
      }
    } catch (e) {}
  });
}

// user visits cart page
function dwInitCartPage() {
  if (document.body.classList.contains("template-cart")) {
    fetch("/cart.js")
      .then((response) => response.json())
      .then((cart) => {
        gtag("event", "view_cart", {
          ecommerce: {
            currency: cart.currency,
            value: cart.total_price / 100,
            items: cart.items.map((item) => ({
              item_id: item.id.toString(),
              item_name: item.product_title,
              item_variant: item.variant_title || "",
              price: item.price / 100,
              quantity: item.quantity,
            })),
          },
          URL: window.location.pathname,
          Titel: document.title,
        });
      })
      .catch((error) => console.error("Error fetching cart:", error));
  }
}

// user opens the cart using theme / adding to cart
function dwInitCartOpen() {
  document.addEventListener("drawerOpen", (event) => {
    fetch("/cart.js")
      .then((response) => response.json())
      .then((cart) => {
        gtag("event", "view_cart", {
          ecommerce: {
            currency: cart.currency,
            value: cart.total_price / 100,
            items: cart.items.map((item) => ({
              item_id: item.id.toString(),
              item_name: item.product_title,
              item_variant: item.variant_title || "",
              price: item.price / 100,
              quantity: item.quantity,
            })),
          },
          URL: window.location.pathname,
          Titel: document.title,
        });
      })
      .catch((error) => console.error("Error fetching cart:", error));
  });
}

// Initialize Scroll Tracking
function dwInitScroll() {
  const scrollMilestones = [25, 50, 75, 90];

  let trackedMilestones = new Set();

  let maxScroll = 0;

  function debounce(func, wait) {
    let timeout;
    return function () {
      const context = this;
      const args = arguments;
      clearTimeout(timeout);
      timeout = setTimeout(() => func.apply(context, args), wait);
    };
  }

  function getScrollPercent() {
    const h = document.documentElement;
    const b = document.body;
    const st = "scrollTop";
    const sh = "scrollHeight";

    return ((h[st] || b[st]) / ((h[sh] || b[sh]) - h.clientHeight)) * 100;
  }

  // Send GA4 event
  function sendScrollEvent(percentage) {
    gtag("event", "scroll", {
      percent_scrolled: percentage,
    });
  }

  const handleScroll = debounce(() => {
    const scrollPercent = Math.round(getScrollPercent());

    maxScroll = Math.max(maxScroll, scrollPercent);

    scrollMilestones.forEach((milestone) => {
      if (maxScroll >= milestone && !trackedMilestones.has(milestone)) {
        trackedMilestones.add(milestone);
        sendScrollEvent(milestone);
      }
    });
  }, 100); // 100ms debounce delay

  window.addEventListener("scroll", handleScroll);

  window.addEventListener("beforeunload", () => {
    handleScroll();
  });
}

// Track clicks on telephone links
function dwInitPhoneLinks() {
  document.addEventListener("click", (event) => {
    const link = event.target.closest("a");
    if (!link) return;

    const href = link.href;
    if (!href || !href.toLowerCase().startsWith("tel:")) return;

    try {
      // Send Google Ads conversion
      gtag("event", "conversion", {
        send_to: "AW-10815322900/WlegCNaplOYZEJT2kqUo",
      });

      // Send GA4 event using gtag
      gtag("event", "contact", {
        phone: window.location.pathname,
      });

      // Send Meta Pixel event
      if (typeof fbq !== "undefined") {
        fbq("track", "Contact");
      }
    } catch (e) {
      // Handle errors silently
    }
  });
}

// Track clicks on mailto links
function dwInitEmailLinks() {
  document.addEventListener("click", (event) => {
    const link = event.target.closest("a");
    if (!link) return;

    const href = link.href;
    if (!href || !href.toLowerCase().startsWith("mailto:")) return;

    try {
      // Send Google Ads conversion
      gtag("event", "conversion", {
        send_to: "AW-10815322900/wHcjCNOplOYZEJT2kqUo",
      });

      // Send GA4 event using gtag
      gtag("event", "contact", {
        mail: window.location.pathname,
      });

      // Send Meta Pixel event
      if (typeof fbq !== "undefined") {
        fbq("track", "Contact");
      }
    } catch (e) {
      // Handle errors silently
    }
  });
}

// Track contact form submissions
function dwInitContactForm() {
  if (window.location.href.includes("/contact-us?contact_posted=true")) {
    try {
      // Send Google Ads conversion
      gtag("event", "conversion", {
        send_to: "AW-10815322900/L9uKCJqmlOYZEJT2kqUo",
      });

      // Send GA4 event using gtag
      gtag("event", "contact", {
        form: window.location.pathname,
      });

      // Send Meta Pixel event
      if (typeof fbq !== "undefined") {
        fbq("track", "Contact");
      }
    } catch (e) {
      // Handle errors silently
    }
  }
}

// review iframe is shown somewhere
function dwInitReviewOpened() {
  let eventFired = false;

  const observer = new MutationObserver((mutations) => {
    if (eventFired) return;

    for (const mutation of mutations) {
      if (mutation.type === "childList") {
        const quickviewIframe = document.querySelector(
          ".loox-overlay #quickview"
        );
        if (quickviewIframe) {
          // Send GA4 event
          gtag("event", "review_opened", {
            URL: window.location.pathname,
            Titel: document.title,
          });

          // Send Meta custom event
          if (typeof fbq !== "undefined") {
            fbq("trackCustom", "Bewertung geöffnet");
          }

          eventFired = true;

          observer.disconnect();
          break;
        }
      }
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
}

// write review iframe is shown somewhere
function dwInitWriteReview() {
  let eventFired = false;

  const observer = new MutationObserver((mutations) => {
    if (eventFired) return;

    for (const mutation of mutations) {
      if (mutation.type === "childList") {
        const quickviewIframe = document.getElementById(
          "loox-review-form-ugc-dialog"
        );
        if (quickviewIframe) {
          // Send GA4 event
          gtag("event", "review_written", {
            URL: window.location.pathname,
            Titel: document.title,
          });

          // Send Meta custom event
          if (typeof fbq !== "undefined") {
            fbq("trackCustom", "Bewertung geschrieben");
          }

          eventFired = true;

          observer.disconnect();
          break;
        }
      }
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
}

// Check for newsletter signup success
function dwInitNewsletterEbook() {
  if (window.location.href.includes("/newsletter-ebook?customer_posted=true")) {
    try {
      // Send GA4 event
      gtag("event", "newsletter", {
        URL: window.location.pathname,
        Titel: document.title,
      });

      // Send Google Ads conversion
      gtag("event", "conversion", {
        send_to: "AW-10815322900/34JICJemlOYZEJT2kqUo",
      });

      // Send Meta Pixel event
      if (typeof fbq !== "undefined") {
        fbq("track", "Subscribe");
      }
    } catch (e) {
      // Handle errors silently
    }
  }
}

function dwInitReturn() {
  document.addEventListener("click", (event) => {
    const link = event.target.closest("a");
    if (!link) return;

    const href = link.href;
    if (!href) return;

    const targetDomains = ["return.weship.at"];

    try {
      const url = new URL(href);
      const domain = url.hostname.replace("www.", "");

      if (targetDomains.includes(domain)) {
        // ga4 event
        gtag("event", "return", {
          URL: href,
          Titel: document.title,
        });

        // meta conversion
        if (typeof fbq !== "undefined") {
          fbq("trackCustom", "Retoure anmelden");
        }
      }
    } catch (e) {
      // Handle errors silently
    }
  });
}

// user activates account
function dwInitCompleteRegistration() {
  if (document.body.classList.contains("template-customers-activate_account")) {
    try {
      // Send GA4 event
      gtag("event", "complete_registration", {
        URL: window.location.pathname,
        Titel: document.title,
      });

      // Send Google Ads conversion
      gtag("event", "conversion", {
        send_to: "AW-10815322900/6Q1rCJGmlOYZEJT2kqUo",
      });

      // Send Meta Pixel event
      if (typeof fbq !== "undefined") {
        fbq("track", "CompleteRegistration");
      }
    } catch (e) {
      // Handle errors silently
    }
  }
}
